/**
 *
 * @param {Event} e
 * @param {String} selector
 * @returns {HTMLElement|null}
 */
export function getElementFromEvent(e, selector) {
	if (!e.target) {
		return null;
	}

	const el = e.target?.closest(selector);

	if (!el) {
		return null;
	}

	return el;
}

export function getKeyboardFocusableElements(element = document) {
	return [
		...element.querySelectorAll(
			'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])'
		),
	].filter(el => !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden'));
}

export function trapFocus(menu) {
	const focusableElements = getKeyboardFocusableElements(menu);
	const firstElement = focusableElements[0];
	const lastElement = focusableElements[focusableElements.length - 1];

	function handleTab(e) {
		const isTabPressed = e.key === 'Tab';

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			// If Shift + Tab is pressed
			if (document.activeElement === firstElement) {
				e.preventDefault();
				lastElement.focus();
			}
		} else {
			// If Tab is pressed
			if (document.activeElement === lastElement) {
				e.preventDefault();
				firstElement.focus();
			}
		}
	}

	// Attach keydown event to trap focus
	menu.addEventListener('keydown', handleTab);

	// Return a function to remove the event listener when needed
	return function removeTrapFocus() {
		menu.removeEventListener('keydown', handleTab);
	};
}

export function plausibleEvent(name, props) {
    try {
        window.plausible && window.plausible(name, {props})
    } catch (e) {
        console.error(e);
    }

}